export const enum CoreBeamId { Pulse = 0, Arc = 1, Prism = 2, Lattice = 3 }
export const enum NodeLensId { Focus = 0, Fan = 1, Mirror = 2, Tether = 3 }
export const enum DeviceId { RepairField = 0, PhaseCut = 1, TimeFold = 2, Overdrive = 3 }

export interface EquipmentDefinition {
  readonly id: number;
  readonly name: string;
  readonly glyph: string;
  readonly description: string;
}

export const CORE_BEAMS: readonly EquipmentDefinition[] = Object.freeze([
  Object.freeze({ id: CoreBeamId.Pulse, name: 'PULSE', glyph: '▸', description: 'Fast, stable forward pulses.' }),
  Object.freeze({ id: CoreBeamId.Arc, name: 'ARC', glyph: '⋔', description: 'Branches vertically after a fixed distance.' }),
  Object.freeze({ id: CoreBeamId.Prism, name: 'PRISM', glyph: '◇', description: 'Creates a bounded refracted follow-up on impact.' }),
  Object.freeze({ id: CoreBeamId.Lattice, name: 'LATTICE', glyph: '⌗', description: 'Slow, low-count grid packets with area control.' }),
]);

export const NODE_LENSES: readonly EquipmentDefinition[] = Object.freeze([
  Object.freeze({ id: NodeLensId.Focus, name: 'FOCUS', glyph: '→', description: 'Concentrates all Node fire.' }),
  Object.freeze({ id: NodeLensId.Fan, name: 'FAN', glyph: '≋', description: 'Each Node fires at a distinct fixed angle.' }),
  Object.freeze({ id: NodeLensId.Mirror, name: 'MIRROR', glyph: '◈', description: 'Reflects eligible bullets under deterministic conditions.' }),
  Object.freeze({ id: NodeLensId.Tether, name: 'TETHER', glyph: '△', description: 'Charges a bounded attack line between Nodes.' }),
]);

export const DEVICES: readonly EquipmentDefinition[] = Object.freeze([
  Object.freeze({ id: DeviceId.RepairField, name: 'REPAIR FIELD', glyph: '+', description: 'Accelerates Node recharge for a short interval.' }),
  Object.freeze({ id: DeviceId.PhaseCut, name: 'PHASE CUT', glyph: '×', description: 'Decomposes small bullets and lightly damages bosses.' }),
  Object.freeze({ id: DeviceId.TimeFold, name: 'TIME FOLD', glyph: '⌁', description: 'Slows enemy projectiles without stopping simulation.' }),
  Object.freeze({ id: DeviceId.Overdrive, name: 'OVERDRIVE', glyph: '!', description: 'Raises output while disabling Node defence.' }),
]);
